import QueryString from "qs"
import http from "../index"
import {
  apiApproveProposal,
  apiCreateProposal,
  apiGetDetailProposal,
  apiGetListProposal,
  apiRefuseProposal,
  apiUpdateProposal,
  apiExportProposal,
  apiExportExcelProposal,
  apiImportInfoSimProposal,
  apiDetailInfoSimProposal,
  apiUpdateDetailInfoSimProposal,
  apiBuyFromProvider,
  apiStatusSim,
} from "./urls"

const createProposal = body => http.post(apiCreateProposal, body)
const getListProposal = params => http.get(apiGetListProposal, { params })
const getDetailProposal = id => http.get(apiGetDetailProposal(id))
const updateProposal = (id, body) => http.put(apiUpdateProposal(id), body)
const approveProposal = id => http.put(apiApproveProposal(id))
const refuseProposal = (id, note) => http.put(apiRefuseProposal(id), note)
const exportProposal = params =>
  http.get(apiExportProposal, { responseType: "blob", params: params })
const exportExcelProposal = params =>
  http.get(apiExportExcelProposal, { responseType: "blob", params: params })
const importInfoSimProposal = (id, body) =>
  http.post(apiImportInfoSimProposal(id), body)
const detailSimProposal = id => http.get(apiDetailInfoSimProposal(id))
const updateDetailSimProposal = body =>
  http.post(apiUpdateDetailInfoSimProposal, body)
const buyFromProvider = body => http.post(apiBuyFromProvider, body)

const postStatusSim = body => http.post(apiStatusSim, body)

const ProposalService = {
  createProposal,
  getListProposal,
  getDetailProposal,
  updateProposal,
  approveProposal,
  refuseProposal,
  exportProposal,
  exportExcelProposal,
  importInfoSimProposal,
  detailSimProposal,
  updateDetailSimProposal,
  buyFromProvider,
  postStatusSim,
}
export default ProposalService

